import React, { useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import { Form, Formik, FormikHelpers } from 'formik';
import { object, string } from 'yup';
import ExpenseCategories from '../Layouts/ExpenseCategoriesForm';
import { showToast } from 'src/utils/showToaster';
import { CircularProgress } from '@mui/material';
import { ExpenseCategoriesFormValues } from 'src/models/ExpenseCategories.model';
import { useGetExpenseCategoriesByIdQuery, useUpdateExpenseCategoriesByIdMutation } from 'src/services/ExpenseCategoriesService';
import ExpenseCategoriesForm from '../Layouts/ExpenseCategoriesForm';

type Props = {
  onClose: () => void;
  selectedExpenseCategoriesId: string
};

const EditExpenseCategoriesWrapper = ({ onClose, selectedExpenseCategoriesId }: Props) => {
  // Form Initial Values
  const [items, setItems] = useState<any>({});

  const { isLoading, isFetching, data } =
    useGetExpenseCategoriesByIdQuery(selectedExpenseCategoriesId);
  const [updateExpenseCategoriesById] = useUpdateExpenseCategoriesByIdMutation();

  useEffect(() => {
    if (!isLoading && !isFetching) {
      setItems(data?.data);
    }
  }, [isLoading, isFetching, data]);
  const initialValues: ExpenseCategoriesFormValues = {
    expenseCategoryName: items?.expenseCategoryName || ''
  };
  // Validation Schema
  const validationSchema = object().shape({
    ExpenseCategoriesName: string().required('Please enter ExpenseCategories name'),
  });

  // Handle Submit
  const handleSubmit = (
    values: ExpenseCategoriesFormValues,
    { setSubmitting, resetForm }: FormikHelpers<ExpenseCategoriesFormValues>
  ) => {
    updateExpenseCategoriesById({ id: selectedExpenseCategoriesId, body: values }).then(
      (res: any) => {
        if (res?.error) {
          showToast("error", res?.error?.data?.message);
        } else {
          if (res?.data?.status) {
            showToast("success", res?.data?.message);
            resetForm();
            onClose();
          } else {
            showToast("error", res?.data?.message);
          }
        }
        setSubmitting(false);
      }
    );
  };


  return (
    <Dialog open maxWidth='xs' fullWidth>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            {(isLoading || isFetching) && (
              <div className="absolute w-[100%] h-[100%] flex justify-center items-center z-10 bg-slate-100 opacity-50">
                <CircularProgress />
              </div>
            )}
            <ExpenseCategoriesForm formikProps={formikProps} onClose={onClose} formType='EDIT' />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default EditExpenseCategoriesWrapper;